var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { DraftType } from "@@/Draft";
import { observable, action, makeObservable } from "mobx";
import { BaseDialogState } from "../UIComponents/BaseDialog";
export class NewDocumentDialogState {
    constructor(createcb) {
        this.createcb = createcb;
        this.basedialogState = new BaseDialogState();
        this.creating = false;
        this.documenttype = DraftType.DOCX;
        this.documentname = "";
        makeObservable(this);
        this.basedialogState.setHeaderLabel("Create Document");
        this.basedialogState.onOk = () => {
            // we will create the draft here!
            console.log('creating ' + this.documenttype);
            this.createcb(this.documentname, this.documenttype);
        };
        this.basedialogState.setOkLabel("Create");
    }
    show() {
        this.setName("");
        this.setDocumentType(DraftType.DOCX);
        this.setCreating(false);
        this.basedialogState.setOpen(true);
    }
    hide() {
        this.basedialogState.setOpen(false);
    }
    setName(name) {
        this.documentname = name;
    }
    setCreating(creating) {
        this.creating = creating;
    }
    setDocumentType(type) {
        console.log('setting doctype ' + type);
        this.documenttype = type;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], NewDocumentDialogState.prototype, "creating", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], NewDocumentDialogState.prototype, "documenttype", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], NewDocumentDialogState.prototype, "documentname", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], NewDocumentDialogState.prototype, "setName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], NewDocumentDialogState.prototype, "setCreating", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], NewDocumentDialogState.prototype, "setDocumentType", null);
